/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TaskRequirementQuestionType {
    '_0' = 0,
    '_1' = 1,
}
